angular.module('pe4h').run(['$templateCache', function($templateCache) {
  $templateCache.put('components/proposals/create/create-proposal.html',
    '<div ng-controller="CreateProposal">\n' +
    '    <!-- Error message -->\n' +
    '    <div ng-show="!user" class="alert over-limit alert-warning mt40" role="alert">\n' +
    '        <a class="close" data-dismiss="alert" aria-label="Close"></a>\n' +
    '        <a href="" ng-click="signUp()">\n' +
    '            Sign up</a>\n' +
    '        or\n' +
    '        <a href="" ng-click="logIn()">Log in</a>\n' +
    '        to create a proposal.\n' +
    '    </div>\n' +
    '\n' +
    '    <div ng-show="projectClosed" class="alert over-limit alert-warning mt40" role="alert">\n' +
    '        <a class="close" data-dismiss="alert" aria-label="Close"></a>\n' +
    '        You can\'t post a proposal because of the project\'s current status.\n' +
    '    </div>\n' +
    '\n' +
    '    <!--div ng-show="projectFull" class="alert over-limit alert-warning mt40" role="alert">\n' +
    '        <a class="close" data-dismiss="alert" aria-label="Close"></a>\n' +
    '        You can\'t post a proposal because the project\'s already full.\n' +
    '    </div-->\n' +
    '\n' +
    '    <h3 class="mt30 mb30">Send Proposal</h3>\n' +
    '\n' +
    '    <!-- Proposal -->\n' +
    '    <div class="message-box">\n' +
    '        <form name="proposalForm" id="proposalForm" ng-submit="createProposal()" autocomplete="off">\n' +
    '            <fieldset ng-disabled="projectClosed || projectFull || !user">\n' +
    '                <h5>Estimate</h5>\n' +
    '                <ul class="list-inline minus-align" ng-if="EstimationType == Estimation.range">\n' +
    '                    <li class="" style="flex: 5">\n' +
    '                        <div class="input-group">\n' +
    '                            <span class="input-group-addon">\n' +
    '                                <i class="fa fa-usd"></i>\n' +
    '                            </span>\n' +
    '                            <input id="lowestRange" name="lowestRange" required="true" ng-model="proposal.LowestRange"\n' +
    '                                ng-pattern="/^\\d{1,9}$/" class="form-control input-lg input-rate" type="number"\n' +
    '                                ng-change="validRangeVerification()"\n' +
    '                                ng-model-options="{ updateOn: \'default blur\', debounce: { \'default\': 1000, \'blur\': 0 }}">\n' +
    '                        </div>\n' +
    '                        <div class="help-block error-message-align"\n' +
    '                            ng-class="{\'errors\': (proposalForm.lowestRange.$touched || proposalForm.highestRange.$touched) && proposalForm.lowestRange.$invalid }"\n' +
    '                            ng-messages="proposalForm.lowestRange.$error"\n' +
    '                            ng-if="proposalForm.lowestRange.$touched || proposalForm.highestRange.$touched">\n' +
    '                            <p ng-message="required">This field is required</p>\n' +
    '                            <p ng-message="number">Invalid! Please enter a whole number value</p>\n' +
    '                            <p ng-message="pattern">Invalid! Please enter a whole number value</p>\n' +
    '                            <p ng-if="isRangeInvalid">{{RangeError}}</p>\n' +
    '                        </div>\n' +
    '                    </li>\n' +
    '                    <li class="vertical-middle minus-vertical-align" style="flex: 1">\n' +
    '                        <i class="fa fa-minus"></i>\n' +
    '                    </li>\n' +
    '                    <li class="" style="flex: 5; padding-right:0px">\n' +
    '                        <div class="input-group">\n' +
    '                            <span class="input-group-addon">\n' +
    '                                <i class="fa fa-usd"></i>\n' +
    '                            </span>\n' +
    '                            <input id="highestRange" name="highestRange" required="true"\n' +
    '                                ng-model="proposal.HighestRange" ng-pattern="/^\\d{1,9}$/"\n' +
    '                                class="form-control input-lg input-rate" type="number"\n' +
    '                                ng-change="validRangeVerification()"\n' +
    '                                ng-model-options="{ updateOn: \'default blur\', debounce: { \'default\': 1000, \'blur\': 0 }}">\n' +
    '                        </div>\n' +
    '                        <div class="help-block error-message-align"\n' +
    '                            ng-class="{\'errors\': (proposalForm.highestRange.$touched ||  proposalForm.lowestRange.$touched) && proposalForm.highestRange.$invalid }"\n' +
    '                            ng-messages="proposalForm.highestRange.$error"\n' +
    '                            ng-if="proposalForm.highestRange.$touched ||  proposalForm.lowestRange.$touched">\n' +
    '                            <p ng-message="required">This field is required</p>\n' +
    '                            <p ng-message="number">Invalid! Please enter a whole number value</p>\n' +
    '                            <p ng-message="pattern">Invalid! Please enter a whole number value</p>\n' +
    '                        </div>\n' +
    '                    </li>\n' +
    '                </ul>\n' +
    '                <ul class="list-inline">\n' +
    '                    <li class="form-group pull-left" style="padding-right:0px"\n' +
    '                        ng-if="EstimationType == Estimation.hourly || EstimationType == Estimation.fixed">\n' +
    '                        <div class="input-group">\n' +
    '                            <span class="input-group-addon">\n' +
    '                                <i class="fa fa-usd"></i>\n' +
    '                            </span>\n' +
    '                            <input id="estimation" name="estimation" required="true" ng-model="proposal.Estimate"\n' +
    '                                ng-value="proposal.Estimate" ng-pattern="/^\\d{1,9}$/" min="0"\n' +
    '                                class="form-control input-lg input-rate" type="number"\n' +
    '                                ng-model-options="{ updateOn: \'default blur\', debounce: { \'default\': 1000, \'blur\': 0 }}"\n' +
    '                                ng-change="calculateEstimateWithFee()">\n' +
    '                        </div>\n' +
    '                        <div class="help-block"\n' +
    '                            ng-class="{\'errors\': proposalForm.estimation.$touched && proposalForm.estimation.$invalid }"\n' +
    '                            ng-messages="proposalForm.estimation.$error" ng-if="proposalForm.estimation.$touched">\n' +
    '                            <p ng-message="required">This field is required</p>\n' +
    '                            <p ng-message="number">Invalid! Please enter a whole number value</p>\n' +
    '                            <p ng-message="pattern">Invalid! Please enter a whole number value</p>\n' +
    '                        </div>\n' +
    '                    </li>\n' +
    '                    <li class="form-group rate-option">\n' +
    '                        <input class="form-control input-lg" ng-model="EstimationType" type="radio"\n' +
    '                            ng-value="Estimation.fixed">\n' +
    '                        <label for="Fixed" ng-click="EstimationType = Estimation.fixed; estimationTypeVerification()">\n' +
    '                            <span></span>Fixed</label>\n' +
    '                    </li>\n' +
    '                    <li class="form-group rate-option" ng-style="((isRangeInvalid && (proposalForm.lowestRange.$touched || proposalForm.highestRange.$touched)) || \n' +
    '                        (proposalForm.lowestRange.$touched && proposalForm.lowestRange.$invalid) || \n' +
    '                        (proposalForm.highestRange.$touched && proposalForm.highestRange.$invalid) || \n' +
    '                        (proposalForm.lowestRange.$touched && proposalForm.highestRange.$invalid) ||\n' +
    '                        (proposalForm.highestRange.$touched && proposalForm.lowestRange.$invalid))\n' +
    '                        && {\'padding-top\': \'2em\'}">\n' +
    '\n' +
    '                        <input class="form-control input-lg" ng-model="EstimationType" type="radio"\n' +
    '                            ng-value="Estimation.hourly">\n' +
    '                        <label for="Hourly" ng-click="EstimationType = Estimation.hourly; estimationTypeVerification()">\n' +
    '                            <span></span>Hourly</label>\n' +
    '                    </li>\n' +
    '                    <li class="form-group rate-option">\n' +
    '                        <input class="form-control input-lg" ng-model="EstimationType" type="radio"\n' +
    '                            ng-value="Estimation.range">\n' +
    '                        <label for="Fixed" ng-click="EstimationType = Estimation.range; estimationTypeVerification()">\n' +
    '                            <span></span>Range</label>\n' +
    '                    </li>\n' +
    '                </ul>\n' +
    '                <div class="clearfix"></div>\n' +
    '                <div class="row">\n' +
    '                    <div class="send-proposal-calculation">\n' +
    '                        <div class="send-proposal-estimation"\n' +
    '                            ng-if="EstimationType == Estimation.hourly || EstimationType == Estimation.fixed">\n' +
    '                            <label class="send-invoice-normal-text send-proposal-estimation-text">Subtotal </label>\n' +
    '                            <label class="send-proposal-right-text"> {{proposal.Estimate | currency:"":2}}</label>\n' +
    '                        </div>\n' +
    '                        <div class="send-proposal-estimation" ng-if="EstimationType == Estimation.range">\n' +
    '                            <label class="send-invoice-normal-text send-proposal-estimation-text">Subtotal </label>\n' +
    '                            <label class="send-proposal-right-text" ng-if="!isRangeInvalid">\n' +
    '                                {{proposal.LowestRange | currency:"":2}} -\n' +
    '                                {{proposal.HighestRange | currency:"":2}}</label>\n' +
    '                        </div>\n' +
    '                        <div class="send-proposal-estimation"\n' +
    '                            ng-if="EstimationType == Estimation.hourly || EstimationType == Estimation.fixed">\n' +
    '                            <label class="send-invoice-normal-text send-proposal-estimation-text">Transaction Fees\n' +
    '                            </label>\n' +
    '                            <label class="send-proposal-right-text"> {{EstimateFee | currency:"":2}}</label>\n' +
    '                        </div>\n' +
    '                        <div class="send-proposal-estimation" ng-if="EstimationType == Estimation.range">\n' +
    '                            <label class="send-invoice-normal-text send-proposal-estimation-text">Transaction Fees\n' +
    '                            </label>\n' +
    '                            <label class="send-proposal-right-text" ng-if="!isRangeInvalid">\n' +
    '                                {{LowestRangeFee | currency:"":2}} - {{HighestRangeFee | currency:"":2}}</label>\n' +
    '                        </div>\n' +
    '                        <div class="send-invoice-separatorline"></div>\n' +
    '                        <div class="send-proposal-estimation"\n' +
    '                            ng-if="EstimationType == Estimation.hourly || EstimationType == Estimation.fixed">\n' +
    '                            <label class="send-invoice-normal-text send-proposal-estimation-text">Total billed to client\n' +
    '                            </label>\n' +
    '                            <label class="send-proposal-right-text"> {{EstimateWithFee | currency:"":2}}</label>\n' +
    '                        </div>\n' +
    '                        <div class="send-proposal-estimation" ng-if="EstimationType == Estimation.range">\n' +
    '                            <label class="send-invoice-normal-text send-proposal-estimation-text">Total billed to client\n' +
    '                            </label>\n' +
    '                            <label class="send-proposal-right-text" ng-if="!isRangeInvalid">\n' +
    '                                {{LowestRangeWithFee | currency:"":2}} - {{HighestRangeWithFee | currency:"":2}}</label>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div class="col-xs-6">\n' +
    '                        <h5>Message</h5>\n' +
    '                    </div>\n' +
    '                    <div class="col-xs-6 mt10">\n' +
    '                        <div class="mt40">\n' +
    '                            <span class="pull-right">\n' +
    '                                <small>char. remaining:</small>\n' +
    '                                <strong>{{charLeft}}</strong>\n' +
    '                            </span>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <textarea ng-model="proposal.Description" required="true" id="proposalMessage" name="proposalMessage"\n' +
    '                    ng-minlength="1" ng-maxlength="3000" class="form-control" rows="10" placeholder="TEXT..."\n' +
    '                    ng-keydown="updateCharLeft()" ng-keyup="updateCharLeft"></textarea>\n' +
    '                <div class="help-block"\n' +
    '                    ng-class="{ \'errors\': proposalForm.proposalMessage.$touched && proposalForm.proposalMessage.$invalid }"\n' +
    '                    ng-messages="proposalForm.proposalMessage.$error" ng-if="proposalForm.proposalMessage.$touched">\n' +
    '                    <p ng-message="required">This field is required</p>\n' +
    '                    <p ng-message="minlength">This field is too short.</p>\n' +
    '                    <p ng-message="maxlength">This field is too long.</p>\n' +
    '                </div>\n' +
    '                <small>Proposal can\'t be edited after posting.</small>\n' +
    '                <div class="row mt10">\n' +
    '                    <div class="col-sm-4 col-md-3 mt5">\n' +
    '                        <span class="btn btn-primary btn-file">\n' +
    '                            <i class="fa fa-paperclip fa-lg"></i>\n' +
    '                            &nbsp;Attach File\n' +
    '                            <input type="file" name="file" id="file" ngf-select ng-model="file" ngf-max-size="20MB"\n' +
    '                                ngf-validate="{size: {max: \'20MB\'}}" class="btn btn-default">\n' +
    '                        </span>\n' +
    '                    </div>\n' +
    '                    <div class="col-sm-8 col-mb-7">\n' +
    '                        <!-- Hide on opening -->\n' +
    '                        <div id="file-attached" class="" ng-show="file!=null">\n' +
    '                            <small style="word-wrap: break-word;">{{file.name}}</small>\n' +
    '                            <a href="javascript:;" class="trash" ng-click="removeFile()"></a>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <div class="row">\n' +
    '                    <div class="help-block" ng-class="{ \'errors\': proposalForm.file.$invalid }"\n' +
    '                        ng-messages="proposalForm.file.$error">\n' +
    '                        <div ng-message="maxSize">\n' +
    '                            <p>File is too large, it must be smaller than 20 Mb</p>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <div class="form-group mt40 mb30">\n' +
    '                    <input class="form-control input-lg" ng-model="agreement" id="i-travel" value="" type="checkbox">\n' +
    '                    <label for="i-travel">\n' +
    '                        <span></span>\n' +
    '                        I agree with the\n' +
    '                        <a href="/terms-and-conditions/"\n' +
    '                            onclick="window.open(this.href,\'new_window\',\'height=600,width=800,resizable=yes,scrollbars=yes\');return false;">Terms\n' +
    '                            &amp; Conditions</a>\n' +
    '                        of P.E. For Hire.</label>\n' +
    '                </div>\n' +
    '                <div class="text-right mt10">\n' +
    '                    <button type="submit" ng-disabled="!agreement || proposalForm.$invalid || isRangeInvalid"\n' +
    '                        class="btn btn-primary btn-lg btn-four">\n' +
    '                        Send\n' +
    '                    </button>\n' +
    '                </div>\n' +
    '            </fieldset>\n' +
    '        </form>\n' +
    '    </div>\n' +
    '</div>');
}]);
